import { ArpMediaType } from '@arpeggi/shared'
import { useMemo } from 'react'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { ArpTable } from '../../arp-table'
import { ArpMediaFilters } from '../../arp-table/hooks'

export const useArpRemixFilters = (media: IArpMedia) => {
  const filters = useMemo<ArpMediaFilters>(() => {
    const { type, id, subComponents } = media
    if (type === ArpMediaType.SAMPLE || type === ArpMediaType.STEM)
      return { ...ArpTable.DEFAULT_SONGS_FILTERS, subComponentId: [id] }
    return { ...ArpTable.DEFAULT_SONGS_FILTERS, subComponentId: subComponents, excludeIds: [id] }
  }, [media])
  return filters
}
